import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Globe2, ArrowRight, Sparkles } from "lucide-react";
import Layout from "../components/layout/Layout";
import CrossCountryShippingSection from "../components/CrossCountryShippingSection";
import { Button } from "../components/ui/button";
import usePageSeo from "../hooks/usePageSeo";
import { CHEEP_SEO } from "../config/mansionSeo";

export default function GlobalShippingPage() {
  const navigate = useNavigate();

  usePageSeo({
    title: CHEEP_SEO.globalShippingTitle,
    description: CHEEP_SEO.globalShippingDescription,
    keywords: CHEEP_SEO.keywords,
    path: "/global-shipping",
  });

  return (
    <Layout>
      <section className="relative bg-slate-950 text-white overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-orange-500/10 via-transparent to-amber-500/5" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 text-center">
          <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}>
            <span className="inline-flex items-center gap-2 bg-orange-500/15 border border-orange-500/30 text-orange-300 text-xs font-semibold px-4 py-2 rounded-full mb-6">
              <Sparkles className="h-4 w-4" />
              Premium cross-country import
            </span>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight mb-6">
              Global Shipping,
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-amber-400">
                One Landed Price
              </span>
            </h1>
            <p className="text-lg text-slate-400 max-w-3xl mx-auto mb-8 leading-relaxed">
              Premium global courier lanes fully integrated. Real-time tracking and comprehensive
              customs brokerage included automatically at checkout.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                size="lg"
                onClick={() => document.getElementById("cross-country-shipping")?.scrollIntoView({ behavior: "smooth" })}
                className="bg-gradient-to-r from-orange-500 to-amber-500 text-white px-8 py-6 text-lg rounded-xl"
                data-testid="global-shipping-quote-cta"
              >
                <Globe2 className="mr-2 h-5 w-5" />
                Get Live Quote
              </Button>
              <Button
                size="lg"
                variant="outline"
                onClick={() => navigate("/submit")}
                className="border-white/30 text-white hover:bg-white/10 px-8 py-6 text-lg rounded-xl"
              >
                Submit Product Link
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </div>
          </motion.div>
        </div>
      </section>

      <CrossCountryShippingSection showTierSelector />
    </Layout>
  );
}
